import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { notifySuccess, notifyError } from '@/lib/notify';
import { escalateChatSession } from '../api';
import { trackChatbotEvent } from '../analytics';

interface EscalationFormProps {
  sessionId: string;
}

export function EscalationForm({ sessionId }: EscalationFormProps) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('Website chatbot support');
  const [question, setQuestion] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await escalateChatSession(sessionId, {
        name,
        email,
        subject,
        question,
        honeypot: '',
      });
      trackChatbotEvent('chatbot_escalated', { chatbot_session_id: sessionId });
      notifySuccess('Message sent. Our team will follow up by email.');
    } catch {
      notifyError('Unable to send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full rounded-2xl border border-gray-200 bg-white p-4 dark:border-white/10 dark:bg-[#2C2C2C]">
      <div className="grid gap-3">
        <div>
          <Label htmlFor="esc-name">Name</Label>
          <Input
            id="esc-name"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="esc-email">Email</Label>
          <Input
            id="esc-email"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="esc-subject">Subject</Label>
          <Input
            id="esc-subject"
            value={subject}
            onChange={e => setSubject(e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="esc-question">How can we help?</Label>
          <Textarea
            id="esc-question"
            rows={4}
            value={question}
            onChange={e => setQuestion(e.target.value)}
          />
        </div>
      </div>
      <Button
        className="mt-4 w-full bg-[#FF6A00] hover:bg-[#e55f00]"
        disabled={submitting}
        onClick={() => void handleSubmit()}
      >
        {submitting ? 'Sending…' : 'Contact support'}
      </Button>
    </div>
  );
}
